import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import TableScheme from "../../components/Admin/Scheme"

const Scheme = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Schemes | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <TableScheme />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Scheme
